import { render, staticRenderFns } from "./info.vue?vue&type=template&id=75f5de34&scoped=true&"
import script from "./info.vue?vue&type=script&lang=ts&"
export * from "./info.vue?vue&type=script&lang=ts&"
import style0 from "./info.vue?vue&type=style&index=0&id=75f5de34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f5de34",
  null
  
)

component.options.__file = "info.vue"
export default component.exports